const langConstants = {
    en: {
        search: "Search",
        searchPlaceholder: "What would you like to watch today?",
    },
    hindi: {
        search: "खोज",
        searchPlaceholder: "आज आप क्या देखना चाहेंगे?",
    },
    spanish: {
        search: "Buscar",
        searchPlaceholder: "¿Qué te gustaría ver hoy?",
    },
}
export default langConstants;